import axios from 'axios'

export const api = axios.create({
	withCredentials: true,
	baseURL: process.env.VUE_APP_SBAPI
})

export const goapi = axios.create({
	withCredentials: true,
	baseURL: process.env.VUE_APP_GOAPI
})
